import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import { deleteItem } from "../../api/generics";
import Town from "../../models/town";

interface TownDeleteModalProps {
  show: boolean;
  town?: Town;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const TownDeleteModal: React.FC<TownDeleteModalProps> = ({
  show,
  town,
  onCancel,
  onSuccess,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const message = town
    ? `Está seguro de que quiere eliminar el Municipio ${town.name}`
    : "";

  const onDeleteClick = async () => {
    if (town !== undefined) {
      setSubmitting(true);
      const townStatus = await deleteItem<Town>(`/towns/${town.id}/`, town);

      if (townStatus.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (townStatus.detail !== undefined) {
          message = townStatus.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-danger" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Eliminar</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onDeleteClick} color="danger">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Eliminando..." : "Eliminar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default TownDeleteModal;
